import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'span';
const idGen = new IDGenerator('wm_icon');

register('wm-icon', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmIcon #${counter}="wmIcon" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
